import { SYSTEM_ADMIN_SESSION_MAX_MS, USER_SESSION_MAX_MS } from 'config'
import { ViewerMode } from 'shared/utils/viewerMode'

const SESSION_MAX_MS_BY_VIEWER_MODE: Record<ViewerMode, number> = {
  [ViewerMode.USER]: USER_SESSION_MAX_MS,
  [ViewerMode.SYSTEM_ADMIN]: SYSTEM_ADMIN_SESSION_MAX_MS,
}

export const getSessionExpiresAt = (
  authTime: string,
  mode: ViewerMode
): number | undefined => {
  const sessionStart = Date.parse(authTime)

  return Number.isNaN(sessionStart)
    ? undefined
    : sessionStart + SESSION_MAX_MS_BY_VIEWER_MODE[mode]
}

export const isSessionExpired = (authTime: string, mode: ViewerMode) => {
  const sessionExpiresAt = getSessionExpiresAt(authTime, mode)

  return sessionExpiresAt !== undefined && sessionExpiresAt <= Date.now()
}
